import { buildContextTableSummaries } from '~/store/fulfillmentContext/helpers';
import { FP_FulfillmentContextService } from '~/store/services/FP_FulfillmentContextService';

const service = new FP_FulfillmentContextService(); //TODO: this should be deprecated

export async function fetchFulfillmentContextSummaries() {
  const [contexts, contacts, addresses, origins, schedules, tenants, tags, contracts, rateSets] = await Promise.all([
    service.fetchFulfillmentContexts(),
    service.fetchContacts(),
    service.fetchAddresses(),
    service.fetchOrigins(),
    service.fetchSchedules(),
    service.fetchTenants(),
    service.fetchTags(),
    service.fetchContracts(),
    service.fetchCarrierRateSets(),
  ]);

  return buildContextTableSummaries({
    contexts,
    contacts,
    addresses,
    origins,
    schedules,
    tenants,
    tags,
    contracts,
    rateSets,
  });
}
